export default __webpack_public_path__ + "static/media/plug-icon.81876460.svg";